(() => {
	let isInit = false;

	function init() {
		const gallery = document.querySelector('#gallery');
		const next = document.querySelector('#gallery-next');
		const prev = document.querySelector('#gallery-prev');

		new Swiper(gallery, {
			loop: true,
			speed: 1000,
			effect: 'fade',
			navigation: {
				nextEl: next,
				prevEl: prev
			}
		});
	}

	// Events
	// ----------------------------------------

	$DOC.ready(() => {
		if ($BODY.hasClass('product-page')) {
			init();
		}
	});

	$WINDOW.on('page:load-completed', (e) => {
		if ($BODY.hasClass('product-page')) {
			init();
		}
	});
})();
